export enum IrisModalSize {
  SM = 'sm',
  MD = 'md'
}
